import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdmin } from "../../contexts/AdminContext";
import {
  ADMIN_HUB,
  ADMIN_LOGIN,
  getAdminHubPath,
  getCustomerHubPath,
  PUBLIC_HUB,
} from "../../utils/appHub";

/**
 * When the user presses browser/PWA back, keep signed-in owners on /profile (not marketing home)
 * and signed-in admins on /admin/dashboard (not the admin login screen). Logo clicks still open /.
 */
export default function AuthenticatedHubGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();

  useEffect(() => {
    if (location.pathname === ADMIN_LOGIN && isAdmin) {
      navigate(ADMIN_HUB, { replace: true });
    }
  }, [location.pathname, isAdmin, navigate]);

  useEffect(() => {
    const onPopState = () => {
      const path = window.location.pathname;
      const customerHub = getCustomerHubPath();
      const adminHub = getAdminHubPath();

      if (path === PUBLIC_HUB && customerHub !== PUBLIC_HUB) {
        // Don't yank users off marketing home while they are mid sticker setup
        // (browser back from /:qrId/setup used to land on / then bounce to /profile).
        let setupActive = false;
        try {
          setupActive = Boolean(sessionStorage.getItem("eqr_setup_active"));
        } catch {
          setupActive = false;
        }
        if (setupActive) return;
        navigate(customerHub, { replace: true });
        return;
      }
      if (path === ADMIN_LOGIN && adminHub === ADMIN_HUB) {
        navigate(ADMIN_HUB, { replace: true });
      }
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [navigate]);

  return null;
}
